"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.BadgeSize = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
// This is an issue of ESLint or a plugin of it - Nothing is shadowed here.
// eslint-disable-next-line no-shadow
var BadgeSize;
(function (BadgeSize) {
    BadgeSize[BadgeSize["withoutText"] = 0] = "withoutText";
    BadgeSize[BadgeSize["small"] = 1] = "small";
    BadgeSize[BadgeSize["medium"] = 2] = "medium";
    BadgeSize[BadgeSize["large"] = 3] = "large";
})(BadgeSize = exports.BadgeSize || (exports.BadgeSize = {}));
const badgeSizeMap = {
    [BadgeSize.withoutText]: { borderRadius: 6, height: 12, width: 12 },
    [BadgeSize.small]: { borderRadius: 10, height: 20, width: 20 },
    [BadgeSize.medium]: { borderRadius: 10, height: 20, width: 27 },
    [BadgeSize.large]: { borderRadius: 10, height: 20, width: 35 },
};
const Badge = (props) => {
    const { height, width, borderRadius } = badgeSizeMap[props.size];
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles.badge,
            {
                backgroundColor: props.borderColor,
                borderRadius,
                height,
                padding: 1,
            },
        ] },
        react_1.default.createElement(react_native_1.View, { style: [
                styles.badge,
                {
                    backgroundColor: props.badgeColor,
                    borderRadius: borderRadius - 1,
                    height: height - 2,
                    width: width - 2,
                },
            ] },
            react_1.default.createElement(react_native_1.View, { style: { justifyContent: 'center' } }, props.children))));
};
exports.Badge = Badge;
const styles = react_native_1.StyleSheet.create({
    badge: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
